import React from 'react'

export function Divider({
    title = '',
}) {

    return (
        <div className="bg-white pt-16 pb-8 flex justify-center">
            <span className="p-4 text-[20px] bg-[#DDEBFC] text-black text-center rounded-full leading-none">
                {title}
            </span>
        </div>
    )
}